import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay } from 'swiper/modules';

import 'swiper/css';

import { useNavigate, useLocation } from "react-router-dom";

import close from '../assets/icon/close.png'

import { ShoppingBag, Heart, Share2, Star, Check, ChevronDown, ChevronUp } from "lucide-react";

import blazer from '../assets/icon/SVG2/coat.svg'

import coat from "../assets/SVG/double button-01.svg";

import trouser from '../assets/icon/SVG2/pant.svg'

import pajama from '../assets/SVG/SVG_PAJAMA/SALWAR-01.svg'

import vest from '../assets/icon/SVG2/vest.svg'

import sadri from '../assets/SVG/SVG_SADRI/STYLE 1-01.svg'

import Shirt from '../assets/icon/SVG2/shirt.svg'

import kurta from '../assets/SVG/SVG_KURTA/kurta.svg'

import NavImg from '../assets/icon/edit.jpg'

import plus from '../assets/icon/plus-thin.svg'

import { useMemo, useState, useEffect } from "react";

import { db } from "../firebase";

import {  getDocOnCondition } from "../Firebase/firestoreGet";

import P_card from "../Presets/preset-card";

import './clothSelect.css'

import NavBar from "../Navbar";

import NewFooter from "../footer";

import tick_green from '../assets/icon/tick1.png'

import Process from '../Homepage/Middle/process';

import SliderSection from './SliderSection';

import suit_e from '../assets/samples/Types/suit.jpg'

import shirt_pant_e from '../assets/samples/Types/shirt_pant.jpg'

import blazer_e from '../assets/samples/Types/blazer.jpg'

import kurta_e from '../assets/samples/Types/kurta.jpg'

import uniform_e from '../assets/samples/Types/uniform.jpg'

import shirt_e from '../assets/samples/Types/shirt.png'

import pant_e from '../assets/samples/Types/pant.jpg'

import sherwani_e from '../assets/samples/Types/sherwani.jpg'

import jubba_e from '../assets/samples/Types/jubba.jpg'

import tshirt_e from '../assets/samples/Types/tshirt.png'

import jackets_e from '../assets/samples/Types/jacket.png'

import longCoat_e from '../assets/samples/Types/long_coat.png'

import { hover, isMotionComponent, motion } from "framer-motion";

import MetaTags from "../meta";

import { tags } from "../Data/metaTags";

import { encodeObj } from "../Functions";

import ChooseWhatToCreate from "./ChooseWhatToCreate/ChooseWhatToCreate";

// ── NEW: Import the three new section components ──────────────────
import CategorySelector from './NewSections/CategorySelector';
import KismePehnnaHai from './NewSections/KismePehnnaHai';
import SubCategorySelector from './NewSections/SubCategorySelector';
import Explore from '../Homepage/Explore/explore';
import ProductCard from '../Presets/preset-card';

// Fix scroll position on mount
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function HeroButton({ children, onClick, className = '', variant = 'filled' }) {

  return (

    <button onClick={onClick} className={`hero-btn ${variant} ${className}`}>

      <span>{children}</span>

    </button>

  );

}

function SeasonalCard({ item, navigate, isMobile }) {

  const [isHovered, setIsHovered] = useState(false);

  const path = `/products/${item.category}/${item.name.replace(/ /g, "-")}/${item.doc}`;

  

  // deliverBy logic

  const deliverBy = (() => {

      const d = new Date();

      d.setDate(d.getDate() + 13);

      return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });

  })();

  return (

    <article

      className={`seasonal-card ${isHovered ? 'hovered' : ''}`}

      onClick={() => {

           window.scrollTo(0, 0);

           navigate(path, {state: { sel: item } });

      }}

      onMouseEnter={() => setIsHovered(true)}

      onMouseLeave={() => setIsHovered(false)}

    >

      <div className='seasonal-card-image'>

          <img 

            src={item.src} 

            alt={item.name} 

          />

        

        {item.customize && (

            <div className="customize-badge">

                <img src="/media/site/customize.gif" alt="customize" />

            </div>

        )}

        

        {/* New/Best Seller Badges from ProductCard */}

        <div className='badge-container'>

          <span className="badge-text badge-best">Best Seller</span>

        </div>

      </div>

      

      <div className="seasonal-card-details">

        <h3>{item.name}</h3>

        <p>Delivered by {deliverBy}</p>

        

        <div className="seasonal-card-footer">

            <div className="price">

                {item.price ? `₹${item.price}` : 'Explore'} 

            </div>

            <div className="actions">

                <button className="icon-btn" onClick={(e) => e.stopPropagation()}>

                    <Heart size={18} strokeWidth={1.5} />

                </button>

                <button className="icon-btn" onClick={(e) => e.stopPropagation()}>

                    <Share2 size={18} strokeWidth={1.5} />

                </button>

                <button 

                  className="icon-btn cart-btn"

                  onClick={(e) => {

                    e.stopPropagation();

                    navigate(path, {state: { sel: item } });

                  }}

                >

                    <ShoppingBag size={16} strokeWidth={1.5} color="white" />

                </button>

            </div>

        </div>

      </div>

    </article>

  );

}

function ClothSelect({isMobile, nav, setFabricTypes, setSel, category, setImgState, setNav, select , types, sel, Navs, Types, process, ID}) {

    const navigate = useNavigate()

    const [showHeader, setShowHeader] = useState(false);

    // ── Scroll Event Listener for Sticky Header ───────────────────
    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 100) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // ── NEW: State for the three new sections ──────────────────────
    // Tracks which main category card is selected (SET or SINGLE)
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    // 'set' | 'single' | null
    const [selectionMode, setSelectionMode] = useState(null);
    // Which single piece was selected (sadri | kurta | pajama | blazer)
    const [selectedSingleId, setSelectedSingleId] = useState(null);
    // Which pairing was chosen in Section B
    const [selectedPairing, setSelectedPairing] = useState(null);
    // Which sub-category was chosen in Section C
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);

    // ── Determines the context key for SubCategorySelector ────────
    // For SETs   → use the set id directly (e.g. 'kurta-pajama')
    // For SINGLEs → use the single piece id (e.g. 'sadri', 'kurta', 'pajama')
    const subCategoryContextKey = selectionMode === 'set'
      ? selectedCategoryId
      : selectedSingleId;

    // ── Handler: user picks a SET category ────────────────────────
    const handleSelectSet = (item) => {
      setSelectedCategoryId(item.id);
      setSelectionMode('set');
      setSelectedSingleId(null);
      setSelectedPairing(null);
      setSelectedSubCategory(null);

      // Update the types array based on set defaults
      if (item.types) {
        item.types.forEach((val, idx) => select(idx, val));
      }
    };

    // ── Handler: user picks a SINGLE piece ────────────────────────
    const handleSelectSingle = (item) => {
      setSelectedCategoryId(item.id);
      setSelectionMode('single');
      setSelectedSingleId(item.id);
      setSelectedPairing(null);
      setSelectedSubCategory(null);
    };

    // ── Handler: user picks a pairing in Section B ────────────────
    const handleSelectPairing = (pair) => {
      setSelectedPairing(pair);
      // Apply the types from this pairing
      if (pair.types) {
        pair.types.forEach((val, idx) => select(idx, val));
      }
    };

    // ── Handler: user picks a sub-category in Section C ───────────
    const handleSelectSubCategory = (subcat) => {
      setSelectedSubCategory(subcat);
      // Apply the types for this sub-category
      if (subcat.defaultTypes) {
        subcat.defaultTypes.forEach((val, idx) => select(idx, val));
      }
      // Scroll to bottom CTA
      setTimeout(() => {
        document.getElementById('cs-cta-bar')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    };

    // ── Build the progress summary text for sticky CTA ────────────
    const progressParts = [
      selectedCategoryId && selectionMode === 'set' ? selectedCategoryId.replace(/-/g, ' ').toUpperCase() : null,
      selectionMode === 'single' && selectedSingleId ? selectedSingleId.toUpperCase() : null,
      selectedPairing ? selectedPairing.label : null,
      selectedSubCategory ? selectedSubCategory.name : null,
    ].filter(Boolean);


    const [presets, setPresets] = useState()

    const images = [ suit_e,

            shirt_pant_e,

            blazer_e,

            kurta_e,

            uniform_e,

            shirt_e,

            pant_e,

            sherwani_e,

            jubba_e,

            tshirt_e,

            jackets_e,

            longCoat_e  ]

    const collections = 

            [

                {name:"Suit / Jodhpuri", image: images[0], ref:"suit/select_cloth/personalize" , active : true},

                {name:"Formal Wear", image:images[1] , ref:"formal/select_cloth/personalize" , active : true},

                {name:"Kurta / Pathani", image:images[3] , ref:"kurta/select_cloth/personalize" , active : true},

                {name:"Blazer", image:images[2] , ref:"blazer/select_cloth/personalize" , active : true},

                {name:"Pant", image:images[6] , ref:"pant/select_cloth/personalize" , active : true},

                {name:"Shirt", image:images[5] , ref:"shirt/select_cloth/personalize" , active : true},

                {name:"Jacket / Sadri", image:images[10] , ref:"sadri/select_cloth/personalize" , active : true},

                {name:"Uniform", image:images[4] , ref:null , active : false},

                {name:"Sharwani", image:images[7] , ref:null , active : false},

                {name:"Jubba", image:images[8] , ref:null , active : false},

                {name:"T-Shirt", image:images[9] , ref:null , active : false},

                {name:"Long Coat", image:images[11] , ref:null, active : false}

                ]

                

    const [Data, setData] = useState(collections.filter(e=>!e.name.toLowerCase().includes(category)).slice(0, 4))

    

    const [hoverC, setHoverC] = useState({status:false, id:0})

    const [activeFaq, setActiveFaq] = useState(null);

    const toggleFaq = (i) => setActiveFaq(activeFaq === i ? null : i);

    const faqData = [

        { q: "How long does shipping take?", a: "Shipping typically takes 2-3 weeks as each garment is custom made to your measurements." },

        { q: "What is your return policy?", a: "We offer a perfect fit guarantee. If it doesn't fit, we'll pay for alterations or remake it for free." },

        { q: "Can I customize the lining?", a: "Yes, we offer a wide range of lining options including solid colors and patterns." },

        { q: "Do you offer alterations?", a: "We provide a credit for local alterations if minor adjustments are needed." }

    ];

    useState(()=>{

        const coll = db.collection(`Presets`)

        const data = getDocOnCondition(coll, 'category', category).then((data)=>{

            setPresets(data)

        })

        

    }, [])

    const submitCloth = ()=>{

           const SELL = { 

                "fabric":{"name":"White Wool", "image":"", "price":""},

                "style":{},

                "price":"",

                "name":"Custom "+category,

                "type":1,

                "state" : 0

            }

            if(category === "suit" || category === "kurta"){

            

            var fabric = {}

            console.log("TYPES :", types)

            for(let i=0;i<types.length;i++){

                if(types[i] === 1){

                    // console.log("From Types : ", Object.keys(Types)[i], Types[Object.keys(Types)[i]])

                    fabric[Object.keys(Types[category])[i]] = {

                        "brand":"" ,// "" Fabric[Object.keys(Types)[i]][0]["brand"], 

                        "name":"" ,//Fabric[Object.keys(Types)[i]][0]["fabric"], 

                        "price":"" ,//Fabric[Object.keys(Types)[i]][0]["price"],

                        "src":"" ,//Fabric[Object.keys(Types)[i]][0]["src"],

                        "default":"",

                        "pos":Types[category][Object.keys(Types[category])[i]]}

                }

            }

            console.log("From nav change, types : ", Object.keys(fabric))

            setFabricTypes(Object.keys(fabric))

            // console.log({

            //     ...sel, 

            //     "types":Object.keys(fabric),

            //     "fabric":fabric

            // })

            // var stylesall_set = {}

            // Object.keys(fabric).forEach((e)=>{

            //     stylesall_set[e] = {

            //             display : {},

            //             style :{}   

            //         }

            // })

            // setStylesAll(stylesall_set)

            setSel({

                ...SELL, 

                "types":Object.keys(fabric),

                "fabric":fabric,

                category:category,

                state : 0

            })

            // console.log({

            //     ...sel, 

            //     "types":Object.keys(fabric),

            //     "fabric":fabric

            // })

            if( category === "kurta" && ( Object.keys(fabric).includes("Coat") || Object.keys(fabric).includes("Sadri") )  ){

                setImgState(-1)

            } else {

                setImgState(0)

            }

            

            // setNav(0);

            const finalObj = {

                ...sel, 

                "types":Object.keys(fabric),

                "fabric":fabric,

                category:category,

                state : 0

            }

            // sessionStorage.setItem('sel', JSON.stringify({

            //     ...sel, 

            //     "types":Object.keys(fabric),

            //     "fabric":fabric,

            //     category:category,

            //     state : 0

            // }

            // ))

            

            // navigate(`/custom/${category}/${Navs[1]}/${process}`)

            navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(finalObj)}`)

        

            

                setNav(1)

        } else {

            var sel_from_storage = {...SELL}

            setImgState(0)

            sel_from_storage["types"] = Object.keys(Types[category])

            sel_from_storage["types"] = sel_from_storage["types"].filter(function(e) { return e !== 'measurement' })

            setFabricTypes(sel_from_storage["types"])

            console.log("types from submit cloth ", sel_from_storage.types)

            

            var fabric = {}

            sel_from_storage.types.forEach((e)=>{

                fabric[e] = {

                    "brand":"" ,

                    "name":"" ,

                    "price":"" ,

                    "src":"" ,

                    "pos":Types[category][e]

                }

            })

            sel_from_storage["fabric"] = fabric;

            sel_from_storage.state = 0;

            

            console.log("From submit cloth", sel_from_storage)

            navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(sel_from_storage)}`)

        

            

                setNav(1)

        }

        

    }

    // Submit with a specific types array (for sub-category selection)

    const submitClothWithCustomTypes = (typesArr)=> {

        const SELL = { 

            "fabric":{"name":"White Wool", "image":"", "price":""},

            "style":{},

            "price":"",

            "name":"Custom "+category,

            "type":1,

            "state" : 0

        }

        if(category === "suit" || category === "kurta"){

            const effectiveTypes = typesArr || types;

            var fabric = {}

            for(let i=0;i<effectiveTypes.length;i++){

                if(effectiveTypes[i] === 1){

                    fabric[Object.keys(Types[category])[i]] = {

                        "brand":"","name":"","price":"","src":"","default":"",

                        "pos":Types[category][Object.keys(Types[category])[i]]

                    }

                }

            }

            setFabricTypes(Object.keys(fabric))

            setSel({...SELL,"types":Object.keys(fabric),"fabric":fabric,category:category,state:0})

            if(category==="kurta"&&(Object.keys(fabric).includes("Coat")||Object.keys(fabric).includes("Sadri"))){

                setImgState(-1)

            } else {

                setImgState(0)

            }

            const finalObj = {...SELL,"types":Object.keys(fabric),"fabric":fabric,category:category,state:0}

            navigate(`/custom/${category}/${Navs[1]}/${process}/${encodeObj(finalObj)}`)

            setNav(1)

        } else {

            submitCloth()

        }

    }

    // Swiper Settings

    const carouselSettings = {

        modules: [Autoplay],

        spaceBetween: 20,

        slidesPerView: 1.2,

        loop: true,

        speed: 1000,

        autoplay: {

        delay: 3000,

        disableOnInteraction: false,

        pauseOnMouseEnter: true

        },

        breakpoints: {

        640: { slidesPerView: 2.2 },

        768: { slidesPerView: 3.2 },

        1024: { slidesPerView: 4 }, 

        },

        className: "w-full pb-8 seasonal-swiper"

    };

    return (

        <div className="sectionSectionFull">

            <ScrollToTop />

            <MetaTags data = {tags[`${category}_custom`]}/>

            <NavBar flag={4} style = {{"position":"relative"}}/>

            <div className="hero-wrapper" style={{backgroundImage:`url(${NavImg})`}}>

                <div className="hero-overlay"></div>

                <div className="hero-content-container">

                    {/* ── LEFT CONTENT ── */}

                    <div className="hero-content-left">

                        {/* Badge */}

                        <div className="hero-badge">

                            <div className="hero-badge-star"></div>

                            Eid Special Launch

                        </div>

                        {/* Title */}

                        <h1 className="hero-title">

                            {tags[`${category}_custom`].h1.split('–')[0]}{tags[`${category}_custom`].h1.includes('–') && (

                                <>– <span className="hero-title-gold">{tags[`${category}_custom`].h1.split('–')[1]?.trim()}</span></>

                            )}

                        </h1>

                        {/* Subtitle */}

                        <div className="hero-desc">

                            {tags[`${category}_custom`].p}

                        </div>

                        {/* Feature Pills */}

                        <div className="hero-pills">

                            <div className="hero-pill">

                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">

                                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>

                                </svg>

                                Custom Fit

                            </div>

                            <div className="hero-pill">

                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">

                                    <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>

                                </svg>

                                Premium Fabrics

                            </div>

                            <div className="hero-pill">

                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">

                                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>

                                </svg>

                                Ethnic Craftsmanship

                            </div>

                        </div>

                        

                    </div>

                    {/* ── RIGHT: Selection Widget ── */}

                    <div className="hero-content-right">

                        {(category==="kurta" || category === "suit") && (

                            <div className="hero-sel-card">

                                <div className="hero-sel-grid">

                                    {/* Item 0 */}

                                    <div

                                        className={`hero-sel-item ${types[0] === 1 ? "selected" : ""}`}

                                        onClick={()=>{ select(0) }}

                                    >

                                        <div className="hero-sel-indicator">

                                            {types[0] === 1 && (

                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">

                                                    <polyline points="2,6 5,9 10,3"/>

                                                </svg>

                                            )}

                                        </div>

                                        <div className="hero-sel-svg-wrap">

                                            {types[0] === 1

                                                ? <img src={category === "suit" ? blazer : kurta} style={{height:"66px",objectFit:"contain"}} alt="" />

                                                : <svg width="46" height="66" viewBox="0 0 48 68" fill="none" stroke="#bbb" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">

                                                    <path d="M14 4 C14 4 10 6 6 10 L4 20 L10 21 L10 62 L38 62 L38 21 L44 20 L42 10 C38 6 34 4 34 4"/>

                                                    <path d="M14 4 L24 14 L34 4"/>

                                                    <line x1="24" y1="14" x2="24" y2="58"/>

                                                    <circle cx="24" cy="22" r="1" fill="#bbb" stroke="none"/>

                                                    <circle cx="24" cy="30" r="1" fill="#bbb" stroke="none"/>

                                                    <circle cx="24" cy="38" r="1" fill="#bbb" stroke="none"/>

                                                  </svg>

                                            }

                                        </div>

                                        <span className="hero-sel-lbl">{Object.keys(Types[category])[0]}</span>

                                    </div>

                                    {/* Item 1 */}

                                    <div

                                        className={`hero-sel-item ${types[1] === 1 ? "selected" : ""}`}

                                        onClick={()=>{ select(1) }}

                                    >

                                        <div className="hero-sel-indicator">

                                            {types[1] === 1 && (

                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">

                                                    <polyline points="2,6 5,9 10,3"/>

                                                </svg>

                                            )}

                                        </div>

                                        <div className="hero-sel-svg-wrap">

                                            {types[1] === 1

                                                ? <img src={category === "kurta" ? coat : Shirt} style={{height:"66px",objectFit:"contain"}} alt="" />

                                                : <svg width="46" height="66" viewBox="0 0 48 68" fill="none" stroke="#bbb" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">

                                                    <path d="M12 3 C12 3 7 7 4 12 L2 24 L10 22 L10 62 L38 62 L38 22 L46 24 L44 12 C41 7 36 3 36 3"/>

                                                    <path d="M17 3 L17 8 L31 8 L31 3"/>

                                                    <line x1="20" y1="10" x2="20" y2="58"/>

                                                    <line x1="28" y1="10" x2="28" y2="58"/>

                                                    <circle cx="20" cy="20" r="1.2" fill="#bbb" stroke="none"/>

                                                    <circle cx="20" cy="30" r="1.2" fill="#bbb" stroke="none"/>

                                                    <circle cx="28" cy="20" r="1.2" fill="#bbb" stroke="none"/>

                                                    <circle cx="28" cy="30" r="1.2" fill="#bbb" stroke="none"/>

                                                  </svg>

                                            }

                                        </div>

                                        <span className="hero-sel-lbl">{Object.keys(Types[category])[1]}</span>

                                    </div>

                                    {/* Item 2 */}

                                    <div

                                        className={`hero-sel-item ${types[2] === 1 ? "selected" : ""}`}

                                        onClick={()=>{ select(2) }}

                                    >

                                        <div className="hero-sel-indicator">

                                            {types[2] === 1 && (

                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">

                                                    <polyline points="2,6 5,9 10,3"/>

                                                </svg>

                                            )}

                                        </div>

                                        <div className="hero-sel-svg-wrap">

                                            {types[2] === 1

                                                ? <img src={category === "kurta" ? pajama : trouser} style={{height:"66px",objectFit:"contain"}} alt="" />

                                                : <svg width="46" height="66" viewBox="0 0 48 68" fill="none" stroke="#bbb" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">

                                                    <rect x="8" y="2" width="32" height="7" rx="2"/>

                                                    <path d="M20 5 C22 3 26 3 28 5"/>

                                                    <path d="M8 9 L6 62 L22 62 L24 30"/>

                                                    <path d="M40 9 L42 62 L26 62 L24 30"/>

                                                    <line x1="24" y1="9" x2="24" y2="30"/>

                                                  </svg>

                                            }

                                        </div>

                                        <span className="hero-sel-lbl">{Object.keys(Types[category])[2]}</span>

                                    </div>

                                    {/* Item 3 */}

                                    <div

                                        className={`hero-sel-item ${types[3] === 1 ? "selected" : ""}`}

                                        onClick={()=>{ select(3) }}

                                    >

                                        <div className="hero-sel-indicator">

                                            {types[3] === 1 && (

                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">

                                                    <polyline points="2,6 5,9 10,3"/>

                                                </svg>

                                            )}

                                        </div>

                                        <div className="hero-sel-svg-wrap">

                                            {types[3] === 1

                                                ? <img src={category === "kurta" ? sadri : vest} style={{height:"66px",objectFit:"contain"}} alt="" />

                                                : <svg width="46" height="66" viewBox="0 0 48 68" fill="none" stroke="#bbb" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">

                                                    <path d="M13 2 C13 2 9 5 7 10 L6 24 L16 22 L16 60 L32 60 L32 22 L42 24 L41 10 C39 5 35 2 35 2"/>

                                                    <path d="M13 2 L24 16 L35 2"/>

                                                    <circle cx="24" cy="24" r="1.2" fill="#bbb" stroke="none"/>

                                                    <circle cx="24" cy="32" r="1.2" fill="#bbb" stroke="none"/>

                                                    <circle cx="24" cy="40" r="1.2" fill="#bbb" stroke="none"/>

                                                  </svg>

                                            }

                                        </div>

                                        <span className="hero-sel-lbl">{Object.keys(Types[category])[3]}</span>

                                    </div>

                                </div>

                                <button className="hero-sel-btn" onClick={()=>{ submitCloth() }}>

                                    Design Now

                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">

                                        <path d="M5 12h14M12 5l7 7-7 7"/>

                                    </svg>

                                </button>

                                <p className="hero-sel-foot">Create your outfit in <span>3 simple steps</span></p>

                            </div>

                        )}

                        {/* Non-kurta/suit: show simple Design Now CTA */}

                        {(category !== "kurta" && category !== "suit") && (

                            <div className="hero-actions">

                                <HeroButton onClick={()=>{submitCloth()}} variant="filled">

                                    Design Now

                                </HeroButton>

                            </div>

                        )}

                    </div>

                </div>

            </div>

            {/* ══════════════════════════════════════════════════════════
                NEW SECTION A: Category & Outfit Type Selector
                Replaces: "Custom Clothing" section
            ════════════════════════════════════════════════════════════ */}
            <CategorySelector
              onSelectSet={handleSelectSet}
              onSelectSingle={handleSelectSingle}
              selectedId={selectedCategoryId}
              process={process}
            />

            {/* ── HOW IT WORKS ──────────────────────────────────────── */}
            <Process />

            {/* ── RELATED PRODUCTS ──────────────────────────────────── */}
            <section className="related-products-section">
              <div className="section-container">
                <h2 className="section-title">Related Products</h2>
                <p className="section-desc">Explore our curated collection of styles that complement your custom creation.</p>
                
                <div className="related-products-grid">
                  {/* Show 8 items (2 rows of 4) */}
                  {presets && presets.slice(0, 8).map((item, key) => (
                    <ProductCard key={key} item={item} />
                  ))}
                </div>
                
                <div className="explore-all-btn-container">
                  <HeroButton variant="black-filled" onClick={() => navigate('/products')}>
                    Explore All
                  </HeroButton>
                </div>
              </div>
            </section>

            {/* ══════════════════════════════════════════════════════════
                NEW SECTION B: Kisme Pehnna Hai (Pairing Selector)
                Replaces: "Fit to Perfection Guaranteed" section
                Shown only when a SINGLE piece is selected
            ════════════════════════════════════════════════════════════ */}
            {selectionMode === 'single' && selectedSingleId && (
              <KismePehnnaHai
                selectedSingleId={selectedSingleId}
                onSelectPairing={handleSelectPairing}
                selectedPairingId={selectedPairing?.id}
              />
            )}

            {/* ══════════════════════════════════════════════════════════
                NEW SECTION C: Sub-Category / Style Selector
                Replaces: "Tailored Suits for a Flawless Fit" section
                Shown when:
                  - SET is selected (no pairing needed), OR
                  - SINGLE + pairing are both selected
            ════════════════════════════════════════════════════════════ */}
            {(selectionMode === 'set' && selectedCategoryId) ||
              (selectionMode === 'single' && selectedPairing) ? (
              <SubCategorySelector
                contextKey={subCategoryContextKey}
                onSelectSubCategory={handleSelectSubCategory}
                selectedSubCategoryId={selectedSubCategory?.id}
              />
            ) : null}

            {/* ══════════════════════════════════════════════════════════
                STICKY CTA BAR — appears after sub-category selected
            ════════════════════════════════════════════════════════════ */}
            {selectedSubCategory && (
              <div className="cs-sticky-cta" id="cs-cta-bar">
                {/* Progress dots */}
                <div className="cs-sticky-cta-progress">
                  <div className={`cs-progress-dot ${selectedCategoryId ? 'done' : ''}`}></div>
                  <div className={`cs-progress-dot ${selectedPairing || selectionMode === 'set' ? 'done' : ''}`}></div>
                  <div className={`cs-progress-dot ${selectedSubCategory ? 'done' : ''}`}></div>
                  <div className="cs-progress-dot"></div>
                </div>

                {/* Summary */}
                <div className="cs-sticky-cta-summary">
                  {progressParts.map((part, i) => (
                    <span key={i}>
                      {i > 0 && <span className="cs-sep"> → </span>}
                      {i === progressParts.length - 1 ? <strong>{part}</strong> : part}
                    </span>
                  ))}
                </div>

                {/* CTA Button — triggers submitCloth with current types */}
                <button className="cs-sticky-cta-btn" onClick={submitCloth}>
                  Continue → Customize
                </button>
              </div>
            )}

            {/* ── CUSTOM TAILORED BY CATEGORIES ─────────────────────── */}
            <div className="custom-tailored-section" style={{ backgroundColor: '#f5f5f5' }}>
              <style>{`
                .custom-tailored-section #explore {
                   background-color: #f5f5f5 !important;
                   padding-top: 50px;
                   padding-bottom: 50px;
                }
              `}</style>
              <Explore images={images} excludeCategory={category} />
            </div>

            {/* ── FAQ (UNCHANGED) ───────────────────────────────────── */}
            <section className="faq-section">
              <div className="section-container">
                <div className="faq-left">
                  <h2 className="section-title">About our Custom Suits</h2>
                  <p>Frequently asked questions about our process, shipping, and customization options.</p>
                  <HeroButton variant="black-filled" style={{ marginTop: '2rem' }}>View FAQ</HeroButton>
                </div>
                <div className="faq-list">
                  {faqData.map((q, i) => (
                    <div key={i} className={`faq-item ${activeFaq === i ? 'active' : ''}`} onClick={() => toggleFaq(i)}>
                      <div className="faq-question">
                        <span>{q.q}</span>
                        <ChevronDown size={16} />
                      </div>
                      <div className="faq-answer"><p>{q.a}</p></div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

        </div>

    )

}

function CustomClothCard({ item }) {

  const [isHovered, setIsHovered] = useState(false);

  

  return (

    <a href={item.ref ? `/custom/${item.ref}` : '#'} style={{textDecoration:"none", display:"block"}}>

        <article

          className={`seasonal-card ${isHovered ? 'hovered' : ''}`}

          onMouseEnter={() => setIsHovered(true)}

          onMouseLeave={() => setIsHovered(false)}

        >

          <div className='seasonal-card-image' style={{ height: '100%' }}>

              <img 

                src={item.image} 

                alt={item.name} 

              />

          </div>

        </article>

        <div className="custom-clothing-label">{item.name}</div>

    </a>

  );

}

export default ClothSelect